export class User {
  constructor(
    public username: string,
    public loggedin: boolean
  ) { }
}
